import { runInAction } from 'mobx';
import { browsingDomainStore } from '../../store';
export const removeFirstSelectedSite = () => {
    runInAction(() => browsingDomainStore.data.selectedSiteIds.shift());
};
